<template>
  <div>
    <slot name="header"></slot>

    <v-combobox
      v-model="remindees"
      :search-input.sync="query"
      class="tw-mt-2 tw-text-sm"
      placeholder="Type an email address and press enter..."
      multiple
      append-icon=""
      solo
      :rules="[validEmails]"
    >
      <template v-slot:selection="data, parent">
        <UserChip
          :user="{ email: data.item, picture: '' }"
          :removable="true"
          :removeEmail="removeEmail"
        ></UserChip>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import UserChip from "@/components/general/UserChip.vue"
import { validateEmail } from "@/utils"

export default {
  name: "EmailReminders",

  props: {
    addedEmails: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    remindees: [], // Currently displayed emails
    query: "",

    emailsAreValid: true, // Whether all emails are valid
  }),

  mounted() {
    this.remindees = this.addedEmails
  },

  methods: {
    /**
     * Removes the specified email from the remindees list.
     */
    removeEmail(email) {
      for (let i = 0; i < this.remindees.length; i++) {
        if (this.remindees[i] == email) {
          this.remindees.splice(i, 1)
        }
      }
    },
    /**
     * Determines if emails are all valid.
     */
    validEmails(emails) {
      for (const email of emails) {
        if (email?.length > 0 && !validateEmail(email)) {
          this.emailsAreValid = false
          return "Please enter a valid email."
        }
      }
      this.emailsAreValid = true
      return true
    },
    reset() {
      this.remindees = this.addedEmails
    },
  },

  watch: {
    remindees() {
      this.$emit("update:emails", this.remindees)
    },
    query() {
      if (this.query && this.query.length > 0) {
        if ( /[,\s]/.test(this.query)) {
          /** If the query has spaces or commas, add the valid emails to the list */
          let successfullyAdded = false
          const emailsArray = this.query.split(/[,\s]+/).filter(email => email.trim() !== "");

          emailsArray.forEach((email) => {
            if (validateEmail(email) && !this.remindees.includes(email)) {
              successfullyAdded = true
              this.remindees.push(email)
            }
          })

          if (successfullyAdded) {
            this.query = ""
            return
          }
        }
      }
    },
  },

  computed: {},

  components: { UserChip },
}
</script>
